// LotWise shared framer-motion variants.
// Consistent motion signature across sections.

export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1];
export const EASE_OUT_QUART = [0.25, 1, 0.5, 1];

// Line-by-line masked reveal (for hero headline lines).
export const lineMaskReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: {
      duration: 0.9,
      ease: EASE_OUT_EXPO,
      delay: 0.08 + i * 0.09,
    },
  }),
};

// Standard fade-up used for section reveals.
export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: EASE_OUT_QUART,
      delay: i * 0.06,
    },
  }),
};

// Staggered container.
export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08 },
  },
};

// Subtle scale + fade for cards.
export const cardReveal = {
  hidden: { opacity: 0, y: 20, scale: 0.985 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.8, ease: EASE_OUT_QUART },
  },
};
